import(/* webpackMode: "eager" */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
import(/* webpackMode: "eager" */ "/app/src/views/privacy/en.tsx");
import(/* webpackMode: "eager" */ "/app/src/views/privacy/es.tsx");
import(/* webpackMode: "eager" */ "/app/src/views/privacy/pt.tsx")